import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import Home from '../../Atom/dashboard/Home'
import Viewproducts from "../../Atom/products/Home"
import Viewpurchases from "../../Atom/purchases/Home"
import Viewcustomers from "../../Atom/customers/Home"
import Viewsuppliers from "../../Atom/suppliers/Home"
import Profitorloss from "../../Atom/profitorloss/Home"
import Norights from "../../Atom/norights/Home"
import Sales from "../../Atom/sales/Home"
import Transactionmpesa from '../../Atom/transactions/Transactionmpesa'
import Expenses from '../../Atom/expenses/Home'
import Purchaseorders from "../../Atom/purchaseorder/Home"
import { AdminRoute } from './AdminRoute' // Add this import

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/home' />} />

        {/* Public Pages (accessible to all authenticated users) */}
        <Route path='home/*' element={<Home />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='norights' element={<Norights />} />

        {/* Admin-Only Protected Routes */}
        <Route
          path='viewproducts'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Viewproducts />
              </Suspense>
            </AdminRoute>
          }
        />

        <Route
          path='viewpurchases'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Viewpurchases />
              </Suspense>
            </AdminRoute>
          }
        />

        <Route
          path='viewcustomers'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Viewcustomers />
              </Suspense>
            </AdminRoute>
          }
        />

        <Route
          path='viewsuppliers'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Viewsuppliers />
              </Suspense>
            </AdminRoute>
          }
        />
        <Route
          path='profitorloss'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Profitorloss />
              </Suspense>
            </AdminRoute>
          }
        />
        <Route
          path='sales'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Sales />
              </Suspense>
            </AdminRoute>
          }
        />
        <Route
          path='transactionsmpesa'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Transactionmpesa />
              </Suspense>
            </AdminRoute>
          }
        />
        <Route
          path='expenses'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Expenses />
              </Suspense>
            </AdminRoute>
          }
        />
        <Route
          path='purchaseorders'
          element={
            <AdminRoute>
              <Suspense fallback={<div>Loading...</div>}>
                <Purchaseorders />
              </Suspense>
            </AdminRoute>
          }
        />

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }